import { render, staticRenderFns } from "./BonusDefinitionModule.vue?vue&type=template&id=36a360c8&"
import script from "./BonusDefinitionModule.vue?vue&type=script&lang=js&"
export * from "./BonusDefinitionModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports